import urlApi from '@/router/urlApi';
import urlApi2 from '@/router/urlApiV2'
import Vue from 'vue'
import Toast from 'vue-toasted'

Vue.use(Toast)
export default {

    // CONSULTAR FATURAS
    async resultConsult(data, callback) {
        Vue.http.post(urlApi2 + '/faturamento/consulta' + data)
            .then(response => {
                callback(response)
                this.launchToast('fa-warning', response.data.mensagem);
            })
            .catch(error => {
                if (error.status === 400) {
                    if (error.data.mensagem === 'Undefined offset: 0') {
                        this.launchToast('fa-warning', 'Nenhum registro encontrado!');
                    } else {
                        this.launchToast('fa-warning', error.data.mensagem);
                    }
                } else {
                    this.launchToast('fa-warning', 'Ops! não foi possivel realizar esta operação!');
                }
                callback(error)
            });
    },

    // GERAR BOLETO
    async selectedGerarBoletos(data, callback) {
        Vue.http.post(urlApi2 + '/boleto/criar', data)
            .then(response => {
                callback(response)
                this.launchToast('fa-warning', response.data.mensagem);
            })
            .catch(error => {
                if (error.status === 400) {
                    if (error.data.mensagem === 'Undefined offset: 0') {
                        this.launchToast('fa-warning', 'Nenhum registro encontrado!');
                    } else {
                        this.launchToast('fa-warning', error.data.mensagem);
                    }
                } else {
                    this.launchToast('fa-warning', 'Ops! não foi possivel realizar esta operação!');
                }
                callback(error)
            });
    },

    // ATUALIZAR BOLETO
    async selectedAtualizarBoletos(data, callback) {
        Vue.http.post(urlApi2 + '/boleto/atualizar', data)
            .then(response => {
                callback(response)
                this.launchToast('fa-warning', response.data.mensagem);
            })
            .catch(error => {
                if (error.status === 400) {
                    if (error.data.mensagem === 'Undefined offset: 0') {
                        this.launchToast('fa-warning', 'Nenhum registro encontrado!');
                    } else {
                        this.launchToast('fa-warning', error.data.mensagem);
                    }
                } else {
                    this.launchToast('fa-warning', 'Ops! não foi possivel realizar esta operação!');
                }
                callback(error)
            });
    },

    // VISUALIZAR BORDERÔ
    async getBordero(data, callback) {
        Vue.http.post(urlApi2 + '/boleto/bordero', data)
            .then(response => {
                callback(response)
                this.launchToast('fa-warning', response.data.mensagem);
            })
            .catch(error => {
                if (error.status === 400) {
                    if (error.data.mensagem === 'Undefined offset: 0') {
                        this.launchToast('fa-warning', 'Nenhum registro encontrado!');
                    } else {
                        this.launchToast('fa-warning', error.data.mensagem);
                    }
                } else {
                    this.launchToast('fa-warning', 'Ops! não foi possivel realizar esta operação!');
                }
                callback(error)
            });
    },

    // ADIAR BLOQUEIO
    async deferBlock(data, callback) {
        Vue.http.post(urlApi2 + '/faturamento/adiar', data)
            .then(response => {
                callback(response)
            })
            .catch(error => {
                if (error.status === 400) {
                    if (error.data.mensagem === 'Undefined offset: 0') {
                        this.launchToast('fa-warning', 'Nenhum registro encontrado!');
                    } else {
                        this.launchToast('fa-warning', error.data.mensagem);
                    }
                } else {
                    this.launchToast('fa-warning', 'Ops! não foi possivel realizar esta operação!');
                }
                callback(error)
            });
    },

    async downloadPlanilhaRetroativa(data, callback) {
        Vue.http.get(urlApi + '/faturamento/planilha?autoescola=', data.schema)
            .then(response => {
                callback(response)
                this.launchToast('fa-warning', response.data.mensagem);
            })
            .catch(error => {
                if (error.status === 400) {
                    if (error.data.mensagem === 'Undefined offset: 0') {
                        this.launchToast('fa-warning', 'Nenhum registro encontrado!');
                    } else {
                        this.launchToast('fa-warning', error.data.mensagem);
                    }
                } else {
                    this.launchToast('fa-warning', 'Ops! não foi possivel realizar esta operação!');
                }
                callback(error)
            });
    },

    // ALERT TOAST
    launchToast(icon, msg) {
        Vue.toasted.show(msg, {
            icon: icon,
            position: 'top-right',
            duration: 5000,
            fullWidth: false
        })
    },

}